import { Injectable } from '@angular/core';
import * as pdfjsLib from 'pdfjs-dist';

/** Initializes and provides access to the pdf.js library and its web-worker for off-thread PDF parsing. */
@Injectable({
  providedIn: 'root',
})
export class PdfWorkerService {
  private static workerInitialized = false;

  constructor() {
    this.initializeWorker();
  }

  private initializeWorker(): void {
    if (!PdfWorkerService.workerInitialized) {
      // Set the worker source path. This is the most compatible way.
      pdfjsLib.GlobalWorkerOptions.workerSrc = 'assets/pdf.worker.min.mjs';
      PdfWorkerService.workerInitialized = true;
    }
  }

  getPdfjsLib() {
    return pdfjsLib;
  }

  isWorkerInitialized(): boolean {
    return PdfWorkerService.workerInitialized;
  }
}
